import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CalendarClock, Loader2 } from 'lucide-react';

const STATE = {
  overdue: ['Overdue', 'bg-red-100 text-red-700'],
  due_soon: ['Due soon', 'bg-amber-100 text-amber-700'],
  on_track: ['On track', 'bg-sky-100 text-sky-700'],
  completed: ['Completed', 'bg-green-100 text-green-700'],
};
const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

export const OrgAssignmentsTable = ({ refreshKey }) => {
  const { api } = useAuth();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get('/organisations/team/assignments').then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [api, refreshKey]);
  return (
    <Card className="border-slate-200" data-testid="org-assignments-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2"><CalendarClock className="h-5 w-5 text-[#20acf6]" /> Assignments with due dates</CardTitle>
        <p className="text-xs text-slate-500">Staff are reminded 7 days and 1 day before. You're emailed if a course becomes overdue.</p>
      </CardHeader>
      <CardContent className="p-0">
        {rows === null ? (
          <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-[#20acf6]" /></div>
        ) : rows.length === 0 ? (
          <p className="text-sm text-slate-500 px-6 pb-6" data-testid="org-assignments-empty">No due dates set yet. Add one when you assign a course.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 border-y border-slate-200 text-slate-600">
                <tr><th className="px-4 py-2.5 text-left font-medium">Staff</th><th className="px-4 py-2.5 text-left font-medium">Course</th>
                  <th className="px-4 py-2.5 text-left font-medium">Due</th><th className="px-4 py-2.5 text-left font-medium">Progress</th><th className="px-4 py-2.5 text-left font-medium">Status</th></tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.enrollment_id} className="border-b border-slate-100" data-testid={`assignment-row-${r.enrollment_id}`}>
                    <td className="px-4 py-2.5"><p className="font-medium text-slate-800">{r.user_name}</p><p className="text-xs text-slate-400">{r.email}</p></td>
                    <td className="px-4 py-2.5 text-slate-700">{r.course_title}</td>
                    <td className="px-4 py-2.5 text-slate-700 whitespace-nowrap">{fmt(r.due_date)}</td>
                    <td className="px-4 py-2.5 text-slate-600">{Math.round(r.progress || 0)}%</td>
                    <td className="px-4 py-2.5"><Badge className={STATE[r.state][1]} data-testid={`assignment-state-${r.enrollment_id}`}>{STATE[r.state][0]}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
